import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import styles from './SashiDoLogo.scss';

export default class SashiDoLogo extends React.Component {
  constructor() {
    super();
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const theme = this.props.theme == 'dark' ? '-dark' : '';

    const logo = (
      this.props.link
        ?
        (
          <Link to="/products/apps" onClick={() => document.body.classList.remove('open')}>
            <img src={`/assets/images/logo${theme}.svg`} width={this.props.size ? this.props.size : 180} alt="SashiDo" />
          </Link>
        )

        :
          <img src={`/assets/images/logo${theme}.svg`} width={this.props.size ? this.props.size : 180} alt="SashiDo" />
    );

    return (
      <div
        style={{ zIndex: this.props.zIndex }}
        className={[
          styles.logo,
          this.props.fade ? styles.fade : null,
          this.props.showUp ? styles.showUp : null,
          this.props.relative ? styles.relative : null,
          ].join(' ')}>
        {logo}
      </div>
    );
  }
}

SashiDoLogo.propTypes = {
  link: PropTypes.bool,
  theme: PropTypes.string,
};
